import {PaymentElement, useElements, useStripe} from '@stripe/react-stripe-js';
import DialogWithCloseIcon from '../ui/dialogs/dialog-with-close-icon';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Box, Button} from '@mui/material';

interface PaymentScreenProps {
  eventPrice: string;
  onSuccess: () => void;
  onError: () => void;
  onCancel: () => void;
}

const PaymentScreen: React.FC<PaymentScreenProps> = ({
  eventPrice,
  onSuccess,
  onError,
  onCancel
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const {t} = useTranslation();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);

    try {
      const {error} = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: window.location.href
        },

        redirect: 'if_required'
      });

      if (error) {
        onError();
      } else {
        onSuccess();
      }
    } catch (err) {
      console.log('payment error: ', err);
      onError();
    } finally {
      setLoading(false);
    }
  };

  return (
    <DialogWithCloseIcon open={true} onClose={onCancel}>
      <form onSubmit={handleSubmit}>
        <Box sx={{padding: 2}}>
          <PaymentElement />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 3
          }}
        >
          <Button
            variant="contained"
            color="primary"
            disabled={loading || !stripe}
            type="submit"
          >
            {t('pay_now', {
              price: eventPrice
            })}
          </Button>
        </Box>
      </form>
    </DialogWithCloseIcon>
  );
};

export default PaymentScreen;
